import { cva, type VariantProps } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import { Text } from '../../';
import type { CommonProps } from '../../types';

import type { JSX } from 'react';

export interface UserInfoProps
    extends CommonProps,
        VariantProps<typeof UserInfoStyles> {
    title: string;
    userValue: string;
}

export const UserInfoStyles = cva('flex flex-col');

export const UserInfo = ({
    className,
    testId = 'user-info',
    title,
    userValue,
}: UserInfoProps): JSX.Element => {
    return (
        <div
            data-testid={testId}
            className={twMerge(UserInfoStyles({ className }))}
        >
            <Text>{title}</Text>
            <Text size="lg" className="mt-1 font-medium">
                {!userValue.length ? '-' : userValue}
            </Text>
            <hr className="my-4 border-gray-300" />
        </div>
    );
};
